<template>
    <!-- https://tailwindui.com/components/application-ui/application-shells/sidebar#component-ba754bf465a594eb075045eb9e940b60 -->
    <div    class="h-screen flex overflow-hidden">
        <!-- Off-canvas menu for mobile -->
        <div v-show="isOn || closing"
                class="lg:hidden">
            <div    class="fixed inset-0 flex z-40"
                    @click="clickScreenWithExpandedSidebar">
                <!--
                  Off-canvas menu overlay, show/hide based on off-canvas menu state.

                  Entering: "transition-opacity ease-linear duration-300"
                    From: "opacity-0"
                    To: "opacity-100"
                  Leaving: "transition-opacity ease-linear duration-300"
                    From: "opacity-100"
                    To: "opacity-0"
                -->
                <transition
                        enter-active-class="transition-opacity ease-linear duration-300"
                        enter-class="opacity-0"
                        enter-to-class="opacity-100"
                        leave-active-class="transition-opacity ease-linear duration-300"
                        leave-class="opacity-100"
                        leave-to-class="opacity-0">
                    <div v-show="isOn"
                         class="fixed inset-0">
                        <div class="absolute inset-0 bg-gray-600 opacity-75"></div>
                    </div>
                </transition>
                <!--
                  Off-canvas menu, show/hide based on off-canvas menu state.

                  Entering: "transition ease-in-out duration-300 transform"
                    From: "-translate-x-full"
                    To: "translate-x-0"
                  Leaving: "transition ease-in-out duration-300 transform"
                    From: "translate-x-0"
                    To: "-translate-x-full"
                -->
                <transition
                        enter-active-class="transition ease-in-out duration-300 transform"
                        enter-class="-translate-x-full"
                        enter-to-class="translate-x-0"
                        leave-active-class="transition ease-in-out duration-300 transform"
                        leave-class="translate-x-0"
                        leave-to-class="-translate-x-full"
                >
                    <div v-show="isOn && sidebarVisible"
                         class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white">
                        <div class="absolute top-0 right-0 -mr-14 p-1">
                            <button @click="closeSidebar()"
                                    class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600"
                                    aria-label="Close sidebar">
                                <svg class="h-6 w-6 text-white" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div    class="display_hide shrink-0 flex items-center px-4"
                                @click="sidebarClicked">
                            <!--                        TODO: do we want this on mobile?-->
                            <slot name="top-left-pane"></slot>
                        </div>
                        <div    class="display_hide mt-5 flex-1 h-0 overflow-y-auto px-2"
                                @click="sidebarClicked">
                            <slot name="left-pane"></slot>
                        </div>
                    </div>
                </transition>
                <div class="shrink-0 w-14">
                    <!-- Dummy element to force sidebar to shrink to fit close icon -->
                </div>
            </div>
        </div>

        <!-- Static sidebar for desktop -->
        <div    v-if="sidebarVisible" class="display_hide hidden lg:flex lg:shrink-0 z-5">
            <div :class="showSidebar ? '' : 'hidden'"
                 class="flex flex-col w-64 border-r border-gray-200 pt-5 pb-4 bg-white">
                <div class="flex items-center shrink-0 px-4">
                    <div id="top-left-pane">
                        <slot name="top-left-pane"></slot>
                    </div>
                </div>
                <div id="left-pane" class="mt-5 h-0 flex-1 flex flex-col overflow-y-auto">
                    <slot name="left-pane"></slot>
                </div>

            </div>
        </div>

        <!-- Header & Content -->
        <div class="flex flex-col w-0 flex-1 overflow-hidden">
            <!-- Move the content div up & down in the z-axis to make sure that any modals show above the header during render. -->
            <div    class="display_hide relative z-30 shrink-0 flex min-h-[5em] bg-white shadow overflow-y-visible"
                    :class="[showingNavDropdown ? 'z-30' : 'z-20']">
                <button v-if="sidebarVisible"
                        @click="isOn = true"
                        :class="showSidebar ? '' : 'hidden'"
                        class="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:bg-gray-100 focus:text-gray-600 lg:hidden"
                        aria-label="Open sidebar">
                    <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7" />
                    </svg>
                </button>

                <!-- Top Right Pane -->
                <div class="flex-1 px-8 flex justify-between overflow-y-visible" id="top-container" ref="topContainer">
                    <div class="flex items-center w-2/3">
                        <top-nav
                            v-show="topNav !== {}"
                            :nav-information="topNav"
                        ></top-nav>
                    </div>
                    <div class="ml-4 flex items-center justify-center md:ml-6">
                        <div id="right-0 pr-1 flex-col content-end justify-start">
                          <slot name="top-right-pane"></slot>
                          <div class="text-right mb-1.5">
                            <navigate-dropdown
                              @navigate-dropdown="updateNavDropdown"
                              v-bind="navDropdownOptions"
                            ></navigate-dropdown>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>

            <div>
                <developer-navigation   v-if="permissions.isSonicu() || permissions.isSonicuViewOnly()"
                                        v-model:nav-open="devNavOpen"
                ></developer-navigation>
            </div>




            <!-- Content -->
            <main class="mt-1 flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
                <div class="pt-2 pb-6 md:py-6 mb-32 sm:mb-0">
<!--                    <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">-->
<!--                        <h1 class="text-2xl font-semibold text-gray-900">Dashboard</h1>-->
<!--                    </div>-->
                    <div class="mx-auto px-4 sm:px-6 md:px-8">
                        <!-- Replace with your content -->
                        <div class="" id="center-pane">
                            <slot name="content"></slot>
                        </div>
                        <!-- /End replace -->
                    </div>
                </div>
            </main>

          <notifications v-if="isLoggedIn" :top-padding="topContainerHeight"></notifications>
        </div>
    </div>
</template>

<script>
    import TopNav from "@/components/TopNav"
    import NavigationDropdown from "@/components/NavigateDropdown"
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
    import DeveloperNavigation from "@/components/DeveloperNavigation";
    import Notifications from "@/components/Notifications.vue";

    export default {
        name: "app.vue",
        mixins: [SonicuCoreMixin],
        components: {DeveloperNavigation, TopNav, NavigationDropdown, Notifications},
        props: {
            showSidebar: {
              type: Boolean,
              default() {
                return true
              }
            },
            topNav: {
                type: Object,
                default() {
                    return {}
                }
            },
            navDropdownOptions: {
                type: Object,
                required: true,
            },
            isLoggedIn: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                isOn: false,
                closing: false,
                protectClose: false,
                showingNavDropdown: false,

                // Dev Navigation
                devNavOpen: false,
                topContainerElement: null,
            }
        },
        created() {
        },
        mounted() {
            document.addEventListener('keyup', ev => {
                // Block Non-Sonicu Users from using this
                if (!(this.permissions.isSonicu() || this.permissions.isSonicuViewOnly())) {
                    return
                }
                if (ev.ctrlKey && ev.key === 'Enter') {
                    this.devNavStart()
                }
            })
            this.$nextTick(() => {  // We wait for the tick to ensure the $refs isn't undefined
                this.topContainerElement = this.$refs.topContainer;
            });

        },
        methods: {
            closeSidebar() {
                let comp = this;
                this.isOn = false
                this.closing = true;
                setTimeout(() => {
                    comp.closing = false
                }, 300)
            },
            clickScreenWithExpandedSidebar() {
                setTimeout(() => {
                    if (this.protectClose) {
                        this.protectClose = false
                        return
                    }
                    this.closeSidebar()
                }, 100)
            },
            sidebarClicked() {
                this.protectClose = true
            },
            updateNavDropdown(val) {
                this.showingNavDropdown = val
            },
            devNavStart() {
                this.devNavOpen = !this.devNavOpen
            },
        },
        computed: {
            sidebarVisible() {
                return !(window.location.href.includes('password/reset'))
            },
            topContainerHeight() {
                if(this.topContainerElement === null || this.topContainerElement === undefined) {
                    return 75 + 15;
                } else {
                    return this.topContainerElement.clientHeight + 15;
                }
            }
        }
    }
</script>

<style scoped>
</style>